import messages from './adminAnalytics.json' with { type: 'json' };

export const adminAnalyticsEn: Readonly<typeof messages> = messages;
